import { createAction, props } from '@ngrx/store';
import { asyncProps, FromApiActionPayload, WithRequestId, AsyncRequest } from '@lib';
import { CheckinPassengerInputResultModel } from './checkin-passenger-input-result.state';

/** StateDetailsActions */
const ACTION_SET = '[CheckinPassengerInputResult] set';
const ACTION_UPDATE = '[CheckinPassengerInputResult] update';
const ACTION_RESET = '[CheckinPassengerInputResult] reset';
const ACTION_FAIL = '[CheckinPassengerInputResult] fail';
const ACTION_CANCEL_REQUEST = '[CheckinPassengerInputResult] cancel request';

/** Async Actions */
const ACTION_SET_FROM_API = '[CheckinPassengerInputResult] set from api';
const ACTION_UPDATE_FROM_API = '[CheckinPassengerInputResult] update from api';

/**
 * Clear the current store object and replace it with the new one,
 * update isFailure to false, and update isPending with the boolean given as parameter if defined
 */
export const setCheckinPassengerInputResult = createAction(
  ACTION_SET,
  props<WithRequestId<CheckinPassengerInputResultModel>>()
);

/**
 * Change a part or the whole object in the store and update isFailure to false. The pendingUpdate boolean,
 * if set to true or false, will update the isPending property from the StateDetails
 */
export const updateCheckinPassengerInputResult = createAction(
  ACTION_UPDATE,
  props<WithRequestId<Partial<CheckinPassengerInputResultModel>>>()
);

/**
 * Clear the whole state, return to the initial one
 */
export const resetCheckinPassengerInputResult = createAction(ACTION_RESET);

/** Action to cancel a Request ID registered in the store. Can happen from effect based on a switchMap for instance */
export const cancelCheckinPassengerInputResultRequest = createAction(ACTION_CANCEL_REQUEST, props<AsyncRequest>());

/**
 * Update isPending from the StateDetails to false, and isFailure to true
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const failCheckinPassengerInputResult = createAction(ACTION_FAIL, props<WithRequestId<{ error: any }>>());

/**
 * Update isPending to true, triggers setFromApi Effect
 */
export const setCheckinPassengerInputResultFromApi = createAction(
  ACTION_SET_FROM_API,
  asyncProps<FromApiActionPayload<CheckinPassengerInputResultModel>>()
);

/**
 * Update isPending to true, triggers updateFromApi Effect
 */
export const updateCheckinPassengerInputResultFromApi = createAction(
  ACTION_UPDATE_FROM_API,
  asyncProps<FromApiActionPayload<CheckinPassengerInputResultModel>>()
);
